<template lang="pug">
  .container
    .columns
      .column.is-12
        h6.subtitle Datos Mensuales
    .columns
      .column.is-2
        .columns
          .column
            b Importe Total del Mes :&nbsp
        .columns
          .column
            b KM Total del Mes:&nbsp
        .columns
          .column
            b Litros Consumidos:&nbsp
        .columns
          .column
            b Promedio KM/L:&nbsp
        .columns
          .column
            b Calidad Consumo:&nbsp
      .column.is-3
        .columns
          .column
            span.tag.is-black
              | {{ data.importeMensual | currency }}
        .columns
          .column
            span.tag
              | {{ data.kmRecorridos }} Kms.
        .columns
          .column
            span.tag
              | {{ data.litrosConsumidos }} Ltrs
        .columns
          .column
            span.tag
              | {{ data.promedio }} km/L
        .columns
          .column
            span.tag
              | {{ data.calidad }}
</template>

<script>
  export default {
    name: 'CardTotales',
    props: {
      data: {
        type: Object,
        default: () => {}
      },
    },
  }
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/components/combustibles_Componentes/componentes/CardTotales.vue